import { lazy } from 'react';

import { Location } from '@cobliteam/common-types';

const ProofOfConclusionPage = lazy(
  () => import('../pages/ProofOfConclusionPage')
);

const routes = [
  {
    path: Location.PROOF_OF_CONCLUSION,
    component: ProofOfConclusionPage,
    exact: true,
    accessDeniedDescription: 'ver comprovantes',
  },
];

export default routes;
